import src from "IMAGE";
export default { src, width: 280, height: 49, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
